<!--
    nav menu side panel for mobile version
-->
<script setup lang="ts">
/* UTILS */
import { ALIconButton } from '@af-lib/vue-ui';
import { computed, inject, ref } from 'vue';

/* COMPONENTS */
import Overlay from '@/components/drawers/Overlay.vue';
import Text from '@/components/text/Text.vue';
import MobileNavDrawerContent from '@/features/navbar/MobileNavDrawerContent.vue';
/* TYPES */
import type { Translate } from '@/types/i18n/i18n.types';
import type { NavItemType } from '@/types/navigation/navigation.types';

// INIT VARIABLES
const contentElement = ref();
const t = inject('t') as Translate;

const currentMenu = ref<NavItemType>(); // Currently selected menu

const isSubmenu = computed(() => !!currentMenu.value); // The current displayed items are a submenu if there is a current selected menu

/* Text to display as side panel header - either raw text or the current menu for which items are displayed */
const headerText = computed(() => {
  if (isSubmenu.value && currentMenu.value) {
    return t(currentMenu.value.label);
  } else {
    return t('general.menu_mobile');
  }
});
</script>

<template>
  <Overlay overlayName="nav">
    <template #content="{ close }">
      <!--HEADER-->
      <div class="text-fontPrimary d-flex justify-space-between align-center pa-4" style="height: 60px">
        <span class="d-flex justify-start align-center">
          <ALIconButton
            v-if="isSubmenu"
            variant="tertiary"
            :label="$t('accessibility.menu.back')"
            class="me-2"
            icon="fas fa-arrow-left"
            @click="contentElement?.reset"
          />
          <Text type="h1">{{ headerText }}</Text>
        </span>
        <ALIconButton
          v-if="!isSubmenu"
          variant="tertiary"
          icon="fa-xmark"
          :label="$t('general.close')"
          @click="close"
        />
      </div>
      <v-divider />
      <!-- CONTENT -->
      <MobileNavDrawerContent
        ref="contentElement"
        class="w-100 overflow-y-auto"
        @updateCurrentMenu="currentMenu = $event"
        @close="close"
      />
    </template>
  </Overlay>
</template>
